import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Widget from "../components/Widget";
import { updateModal } from "../actions/modal";
import { portalConfig } from "../lib/portal";
import { selectedMainEntity } from "../lib/mainEntitySelection";
import { updateExperiment } from "../actions/experiment";

class WidgetContainer extends PureComponent {
  render() {
    try {
      const {
        clientConfig,
        filter,
        offerType,
        sponsoredPositionCount,
        updateExperiment,
        updateModal
      } = this.props;

      const selectedEntity = selectedMainEntity(offerType, filter);

      if (clientConfig != null) {
        return (
          <Widget
            clientConfig={clientConfig}
            selectedEntity={selectedEntity}
            sponsoredPositionCount={sponsoredPositionCount}
            offerType={offerType}
            portal={this.portal()}
            updateExperiment={updateExperiment}
            updateModal={updateModal}
          />
        );
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }

  portal() {
    const { portalId } = this.props;
    return portalConfig(portalId);
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    filter: state.filter[state.offerType],
    offerType: state.offerType,
    portalId: state.portalId,
    sponsoredPositionCount: state.portalData.entities.sponsoredPositions.length
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateExperiment: experimentId => {
      dispatch(updateExperiment(experimentId));
    },
    updateModal: (data, type) => {
      dispatch(updateModal(data, type));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { updateExperiment } = dispatchProps;
  const { clientConfig } = stateProps;

  let updateExperimentValue = false;
  if (clientConfig != null && clientConfig.options.abTesting) {
    updateExperimentValue = function(experimentId) {
      updateExperiment(experimentId);
    };
  }

  return {
    ...stateProps,
    ...dispatchProps,
    updateExperiment: updateExperimentValue
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WidgetContainer);
